import { CheckboxTypeComponent } from './checkbox-type/checkbox-type.component';
import { ImageTypeComponent } from './image-type/image-type.component';
import { InputTypeComponent } from './input-type/input-type.component';
import { LabelTypeComponent } from './label-type/label-type.component';
import { ResourceTypeComponent } from './resource-type/resource-type.component';
import { SelectTypeComponent } from './select-type/select-type.component';
import { TableInputTypeComponent } from './table-input-type/table-input-type.component';
import { ToggleTypeComponent } from './toggle-type/toggle-type.component';

export const types = [
  { name: 'input', component: InputTypeComponent },
  { name: 'select', component: SelectTypeComponent },
  { name: 'table-input', component: TableInputTypeComponent },
  { name: 'label', component: LabelTypeComponent },
  { name: 'image', component: ImageTypeComponent },
  { name: 'resource', component: ResourceTypeComponent },
  { name: 'checkbox', component: CheckboxTypeComponent },
  { name: 'toggle', component: ToggleTypeComponent },
];

export const typeComponents = [
  InputTypeComponent,
  SelectTypeComponent,
  TableInputTypeComponent,
  LabelTypeComponent,
  ImageTypeComponent,
  ResourceTypeComponent,
  CheckboxTypeComponent,
  ToggleTypeComponent,
];
